// extracted by mini-css-extract-plugin
module.exports = {"container":"MyCollectionSection_container__O5PL6"};